export enum MacronutrientEnum {
  CARBOHYDRATES = 'carbohydrates',
  LIPIDS = 'lipids',
  PROTEIN = 'protein',
  FIBER = 'fiber',
}
